import React, { useState } from 'react'
import './style.css'
import downArrow from '../../../assets/images/icons/down-arrow.svg'
import upArrow from '../../../assets/images/icons/up-arrow.svg'
import { debounce } from 'lodash'
import rightArrow from '../../../assets/images/icons/see-all.svg'
import { analyticsEvent } from '../Analytics/AnalyticsEvent'

export default function ReactMoreReadLess({
  children,
  lines,
  moreText,
  lessText,
  showArrow,
  addNewLines,
  top = '0px',
  bottom = '0px',
  isExpand,
  handlerFunction,
  isCustomIcon,
  analytics,
  analyticsProps,
}) {
  const text = children
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  const [showButton, setShowButton] = React.useState(true)
  const containerRef = React.useRef(null)
  let lineBreaks = []

  for (let i = 0; i < addNewLines; i++) {
    lineBreaks.push('</br>')
  }

  React.useEffect(() => {
    const hasClamping = (el) => {
      const { clientHeight, scrollHeight } = el
      return clientHeight !== scrollHeight
    }

    const checkButtonAvailability = () => {
      if (containerRef.current) {
        // Save current state to reapply later if necessary.
        const hadClampClass = containerRef.current.classList.contains('clamp')
        // Make sure that CSS clamping is applied if aplicable.
        if (!hadClampClass) containerRef.current.classList.add('clamp')
        // Check for clamping and show or hide button accordingly.
        setShowButton(hasClamping(containerRef.current))
        // Sync clamping with local state.
        if (!hadClampClass) containerRef.current.classList.remove('clamp')
      }
    }

    const debouncedCheck = debounce(checkButtonAvailability, 50)

    checkButtonAvailability()
    window.addEventListener('resize', debouncedCheck)

    return () => {
      window.removeEventListener('resize', debouncedCheck)
    }
  }, [containerRef])
  return (
    <>
      <p
        className={isReadMore ? 'text clamp' : 'text'}
        style={{ margin: '0px', WebkitLineClamp: lines }}
        ref={containerRef}
      >
        {text}
        {/* {isReadMore ? text.slice(0, textLength) : text} */}
      </p>
      <p
        onClick={isExpand ? handlerFunction : toggleReadMore}
        className="read-or-hide headline2"
        style={{ marginTop: top, marginBottom: bottom }}
      >
        {isReadMore && showButton && (
          <span style={{ display: 'flex' }}>
            {lineBreaks.map((item) => {
              return <br />
            })}
            {analytics ? (
              <span
                onClick={() => {
                  analyticsEvent.clickEvent(
                    analyticsProps.page,
                    analyticsProps.eventName,
                  )
                }}
              >
                {moreText}
              </span>
            ) : (
              <span>{moreText}</span>
            )}

            {showArrow && (
              <img src={isCustomIcon ? rightArrow : downArrow} alt="down"></img>
            )}
          </span>
        )}
        {!isReadMore && showButton && (
          <span style={{ display: 'flex' }}>
            <span>{lessText}</span>
            {showArrow && <img src={upArrow} alt="up"></img>}
          </span>
        )}
        {/* {showButton && <button>Read {isReadMore ? 'more' : 'less'}</button>} */}
      </p>
    </>
  )
}
